import {
  DashboardIcon,
  LockIcon,
  MyQuestionIcon,
  NotifictionIcon,
  ProfileIcon,
  NewHomeIcon,
  ContentCommsIcon,
  InvestorQuestionIcon,
  NewManageInvestorIcon,
  NewSettingIcon,
  SideBarNew1,
  SideBarNew2,
  SideBarNew3,
  SideBarNew4,
  AnalyticsIcon,
  CapitalEventsIcon,
  BoardReportsIcon
} from '@/src/assets/icons'

export const NewSideBarMenu = (CurrTab: any) => {
  return [
    {
      href: '/manage-subscriptions',
      name: 'Manage Subscription',
      id: 'manage-subscriptions',
      title: 'Manage Subscriptions',
      icon: <DashboardIcon className={`h-6 w-6 fill-white`} />,
      titleClassName: CurrTab === '/manage-subscriptions' ? 'text-white' : 'text-darkGray'
    },
    {
      href: '/manage-nominee',
      name: 'Nominee Masterlist',
      id: 'manage-nominee',
      title: 'Nominee Masterlist',
      icon: <DashboardIcon className={`h-6 w-6 fill-white`} />,
      titleClassName: CurrTab === '/manage-nominee' ? 'text-white' : 'text-darkGray'
    },
    {
      href: '/manage-super-admin',
      name: 'Manage Super Admin',
      id: 'manage-super-admin',
      title: 'Manage Super-Admin',
      icon: <NewManageInvestorIcon className={`h-6 w-6 fill-white`} />,
      titleClassName: CurrTab === '/manage-super-admin' ? 'text-white' : 'text-darkGray'
    },
    {
      href: '/manage-settings',
      name: 'Manage Settings',
      id: 'manage-settings',
      title: 'Manage settings',
      icon: <NewSettingIcon className={`h-6 w-6 fill-white`} />,
      titleClassName: CurrTab === '/manage-settings' ? 'text-white' : 'text-darkGray'
    },
    {
      href: '/admin',
      name: 'Dashboard',
      id: 'dashboard',
      title: 'Home',
      icon: (
        <NewHomeIcon
          className={`h-6 w-6 fill-[#6D6E6E]
          ${CurrTab === '/Home' ? 'fill-primary-main' : 'fill-icon-darkGray'}`}
        />
      ),
      titleClassName: CurrTab === '/Home' ? 'white' : 'text-darkGray'
    },
    {
      href: '/analytics',
      name: 'Analytics',
      id: 'analytics',
      title: 'Analytics',
      icon: (
        <AnalyticsIcon
          className={`h-6 w-6 fill-[#6D6E6E]
          ${CurrTab === '/Home' ? 'fill-primary-main' : 'fill-icon-darkGray'}`}
        />
      ),
      titleClassName: CurrTab === '/Home' ? 'white' : 'text-darkGray'
    },
    {
      href: '/capital-events',
      // Visibility is special-cased in newSideBar.tsx: shows when the user
      // can read Placements or Post IPO AND the matching tenant flag is on.
      name: 'Capital Events',
      id: 'capital_events',
      title: 'Capital Events',
      icon: (
        <CapitalEventsIcon
          className={`h-6 w-6 ${
            CurrTab.startsWith('/capital-events') ? 'fill-primary-main' : 'fill-icon-darkGray'
          }`}
        />
      ),
      titleClassName: CurrTab.startsWith('/capital-events') ? 'white' : 'text-darkGray'
    },
    {
      href: '/board-reports',
      name: 'Board Reports',
      id: 'board_reports',
      title: 'Board Reports',
      icon: (
        <BoardReportsIcon
          className={`h-6 w-6 ${
            CurrTab === '/board-reports' ? 'fill-primary-main' : 'fill-icon-darkGray'
          }`}
        />
      ),
      titleClassName: CurrTab === '/board-reports' ? 'white' : 'text-darkGray'
    },
    {
      href: '/manage-content',
      name: 'Manage Content',
      id: 'manage_content',
      title: 'Investor Content',
      icon: (
        <SideBarNew1
          className={`h-6 w-6 ${
            CurrTab === '/manage-content' ? 'fill-primary-main' : 'fill-icon-darkGray'
          }`}
        />
      ),
      titleClassName: CurrTab === '/manage-content' ? 'white' : 'text-darkGray'
    },
    {
      href: '/social-sharing',
      name: 'Social Sharing',
      id: 'social_sharing',
      title: 'Social Posts',
      icon: (
        <SideBarNew2
          className={`h-6 w-6 ${
            CurrTab === '/social-sharing' ? 'fill-primary-main' : 'fill-icon-darkGray'
          }`}
        />
      ),
      titleClassName: CurrTab === '/social-sharing' ? 'white' : 'text-darkGray'
    },
    {
      href: '/broadcast-email',
      name: 'Broadcast Email',
      id: 'broadcast_email',
      title: 'Email Broadcasts',
      icon: (
        <SideBarNew3
          className={`h-6 w-6 ${
            CurrTab === '/broadcast-email' ? 'fill-primary-main' : 'fill-icon-darkGray'
          }`}
        />
      ),
      titleClassName: CurrTab === '/broadcast-email' ? 'white' : 'text-darkGray'
    },
    {
      href: '/questions',
      name: 'Questions',
      id: 'questions',
      title: 'Investor Questions',
      icon: (
        <InvestorQuestionIcon
          className={`h-[1.75rem] w-[1.5rem] fill-[#6D6E6E]

           ${CurrTab === '/questions' ? 'fill-primary-main' : 'fill-icon-darkGray'}
          `}
        />
      ),
      titleClassName: CurrTab === '/questions' ? 'white' : 'text-darkGray'
    },
    {
      href: '/manage-investors',
      name: 'Manage Investors',
      id: 'manage_investors',
      title: 'Manage Investors',
      icon: (
        <NewManageInvestorIcon
          className={`h-6 w-6 fill-[#565E6D]
          ${CurrTab === '/manage-investors' || CurrTab.startsWith('/tags') || CurrTab.startsWith('/segments') ? 'fill-primary-main' : 'fill-icon-darkGray'}`}
        />
      ),
      titleClassName: CurrTab === '/manage-investors' || CurrTab.startsWith('/tags') || CurrTab.startsWith('/segments') ? 'white' : 'text-darkGray',
      children: [
        {
          href: '/tags',
          name: 'Manage Investors',
          id: 'manage-investors-tags',
          title: 'Tags',
          titleClassName: CurrTab.startsWith('/tags') ? 'text-white' : 'text-darkGray'
        },
        {
          href: '/segments',
          name: 'Manage Investors',
          id: 'manage-investors-segments',
          title: 'Segments',
          titleClassName: CurrTab.startsWith('/segments') ? 'text-white' : 'text-darkGray'
        }
      ]
    },
    {
      href: '/asx-drafts',
      name: 'ASX Announcements',
      id: 'content_creator',
      title: 'Draft Announcements',
      icon: (
        <SideBarNew4
          className={`h-6 w-6 ${
            CurrTab === '/asx-drafts' ? 'fill-primary-main' : 'fill-icon-darkGray'
          }`}
        />
      ),
      titleClassName: CurrTab === '/asx-drafts' ? 'white' : 'text-darkGray'
    },
    {
      href: '/company-reports',
      name: 'Company Reports',
      id: 'company_reports',
      // Sits with Draft Announcements: this is a drafting workbench for the
      // formal quarterly announcement, not a generated analytical report.
      title: 'Draft Quarterly Reports',
      icon: (
        <ContentCommsIcon
          className={`h-6 w-6 ${
            CurrTab === '/company-reports' ? 'fill-primary-main' : 'fill-icon-darkGray'
          }`}
        />
      ),
      titleClassName: CurrTab === '/company-reports' ? 'white' : 'text-darkGray'
    },
    {
      href: '/settings',
      name: 'Settings',
      id: 'settings',
      title: 'Settings',
      icon: <NewSettingIcon className={`h-6 w-6 fill-white`} />,
      titleClassName: CurrTab === '/settings' ? 'white' : 'text-darkGray'
    }
  ]
}

// Intent clusters for the admin sidebar. A subtle divider is rendered
// between consecutive VISIBLE items whose group differs (see newSideBar),
// so permission gating never leaves a stray divider. The clusters are
// deliberately unlabelled - the separation communicates the mental model
// (understand / engage / create / admin) without forcing users to learn it.
export const SIDEBAR_GROUPS: Record<string, number> = {
  // Master-admin tools
  'manage-subscriptions': 0,
  'manage-nominee': 0,
  'manage-super-admin': 0,
  'manage-settings': 0,
  // Understand: what is happening on my register
  dashboard: 1,
  analytics: 1,
  capital_events: 1,
  board_reports: 1,
  // Engage: investor-facing content and audiences
  manage_content: 2,
  social_sharing: 2,
  broadcast_email: 2,
  questions: 2,
  manage_investors: 2,
  // Create: disclosure drafting
  content_creator: 3,
  company_reports: 3,
  // Admin
  settings: 4
}

export const UserSidebarData = (CurrTab: string) => {
  return [
    {
      href: '/my-profile',
      name: 'My Profile',
      id: 'my_profile',
      title: 'My Profile',
      icon: <ProfileIcon className={`cursor-pointer h-8 w-8 fill-white`} />,
      titleClassName: CurrTab === '/my-profile' ? 'text-white' : 'text-darkGray'
    },
    {
      href: '/my-questions',
      name: 'My Questions',
      id: 'my_questions',
      title: 'My Questions',
      icon: <MyQuestionIcon className={`h-8 w-8 cursor-pointer fill-white`} />,
      titleClassName: CurrTab === '/my-questions' ? 'text-white' : 'text-darkGray'
    },
    {
      href: '/notification-preferences',
      name: 'Notification preferences',
      id: 'notification_prefrence',
      title: 'Notification preferences',
      icon: <NotifictionIcon className={`fill-white h-8 w-8 cursor-pointer`} />,
      titleClassName: CurrTab === '/notification-preferences' ? 'text-white' : 'text-darkGray'
    },

    {
      href: '/security',
      name: 'Login & Security',
      id: 'login_security',
      title: 'Login & Security',
      icon: <LockIcon className={`fill-white h-8 w-8 cursor-pointer`} />,
      titleClassName: CurrTab === '/security' ? 'text-white' : 'text-darkGray'
    }
  ]
}
